"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListChildren = void 0;
var _react = require("react");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const emptyArr = [];
const useListChildren = function (items) {
  let isShowAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [visibleChildren, setVisibleChildren] = (0, _react.useState)(items);
  const [hiddenChildren, setHiddenChildren] = (0, _react.useState)([]);
  const outerDivRef = (0, _react.useRef)(null);
  const extraRef = (0, _react.useRef)(null);
  const contentRef = (0, _react.useRef)(null);
  const setListChildren = (0, _react.useCallback)(() => {
    if (isShowAll) {
      setVisibleChildren(items);
      setHiddenChildren(emptyArr);
    } else if (outerDivRef.current && contentRef.current) {
      const outerRect = outerDivRef.current.getBoundingClientRect();
      const children = Array.from(contentRef.current.querySelectorAll('[data-is-visible=true]'));
      let menuWidth = 0;
      if (extraRef.current) {
        menuWidth = extraRef.current.getBoundingClientRect().width;
      }
      const childrenTotalWidth = children.reduce((totalWidth, child) => {
        return totalWidth + child.getBoundingClientRect().width;
      }, 0);
      if (childrenTotalWidth > outerRect.width - menuWidth) {
        const tempVisibleChildren = [...visibleChildren];
        const tempHiddenChildren = [...hiddenChildren];
        const child = tempVisibleChildren.pop();
        if (child) {
          tempHiddenChildren.unshift(child);
        }
        setVisibleChildren(tempVisibleChildren);
        setHiddenChildren(tempHiddenChildren);
      }
    }
  }, [hiddenChildren, isShowAll, items, visibleChildren]);
  const getChildHeight = () => {
    if (contentRef.current) {
      const children = Array.from(contentRef.current.children);
      return children[0].getBoundingClientRect().height;
    }
  };
  (0, _react.useEffect)(() => {
    const debounced = (0, _debounce.default)(() => {
      setVisibleChildren(items);
      setHiddenChildren([]);
    }, 200);
    debounced();
    window.addEventListener('resize', debounced);
    return () => {
      window.removeEventListener('resize', debounced);
    };
  }, [items]);
  (0, _react.useEffect)(() => {
    if (visibleChildren.length) {
      setListChildren();
    }
  }, [setListChildren, visibleChildren.length]);
  return {
    outerDivRef,
    contentRef,
    extraRef,
    visibleChildren,
    setVisibleChildren,
    hiddenChildren,
    setHiddenChildren,
    getChildHeight
  };
};
exports.useListChildren = useListChildren;